import React, { useState } from 'react';
import { ROLE_OPTIONS } from '../../../constants/roles';
import {
  Box,
  Typography,
  Paper,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  CircularProgress,
  Snackbar,
  Alert,
  Stack
} from '@mui/material';
import CampaignIcon from '@mui/icons-material/Campaign';
import api from '../../../services/api';
import { t } from '../../../utils/textUtils';

const roles = [
  { value: 'all', label: 'SEMUA USER' },
  ...ROLE_OPTIONS,
];

const BlastNotification = () => {
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');
  const [targetRole, setTargetRole] = useState('all');
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ open: false, message: '', severity: 'success' });

  const handleSubmit = async () => {
    const trimmedMessage = message.trim();
    if (!trimmedMessage) {
      setAlert({
        open: true,
        message: 'Pesan tidak boleh kosong.',
        severity: 'error'
      });
      return;
    }

    if (targetRole === 'all') {
      const confirmed = window.confirm('Kirim notifikasi ke semua user?');
      if (!confirmed) return;
    }

    try {
      setLoading(true);
      await api.post('/notifications/blast', {
        title: title.trim() || undefined,
        message: trimmedMessage,
        roles: targetRole === 'all' ? [] : [targetRole]
      });
      setAlert({
        open: true,
        message: 'Notifikasi berhasil dikirim.',
        severity: 'success'
      });
      setTitle('');
      setMessage('');
      setTargetRole('all');
    } catch (error) {
      setAlert({
        open: true,
        message: error.response?.data?.message || 'Gagal mengirim notifikasi.',
        severity: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <Box sx={{ mb: 2 }}>
        <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <CampaignIcon fontSize="small" />
          {t('Kirim Blast Notif')}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {t('Kirim notifikasi ke semua user atau berdasarkan role yang dipilih')}
        </Typography>
      </Box>

      <Paper sx={{ p: 3 }}>
        <Stack spacing={2}>
          <TextField
            label={t('Judul (Opsional)')}
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder={t('Contoh: Pengumuman Sistem')}
            fullWidth
          />

          <TextField
            label={t('Pesan')}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder={t('Tulis pesan notifikasi di sini')}
            multiline
            minRows={4}
            fullWidth
            required
          />

          <FormControl fullWidth>
            <InputLabel id="blast-role-label">{t('Target')}</InputLabel>
            <Select
              labelId="blast-role-label"
              label={t('Target')}
              value={targetRole}
              onChange={(e) => setTargetRole(e.target.value)}
            >
              {roles.map((role) => (
                <MenuItem key={role.value} value={role.value}>
                  {role.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              variant="contained"
              onClick={handleSubmit}
              disabled={loading}
              startIcon={loading ? <CircularProgress size={18} /> : <CampaignIcon />}
            >
              {loading ? t('Mengirim...') : t('Kirim Notifikasi')}
            </Button>
          </Box>
        </Stack>
      </Paper>

      <Snackbar
        open={alert.open}
        autoHideDuration={5000}
        onClose={() => setAlert(prev => ({ ...prev, open: false }))}
      >
        <Alert
          onClose={() => setAlert(prev => ({ ...prev, open: false }))}
          severity={alert.severity}
          sx={{ width: '100%' }}
        >
          {alert.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default BlastNotification;
